import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { AssetVersionChip } from '~/components/AssetModalV2/components/AssetVersionChip';
import { useVersionsPanelToggle } from '~/components/AssetModalV2/hooks/useVersionsPanelToggle';
import { useCanViewAllVersionsOnPublicShareLink } from '~/hooks/useCanViewAllVersionsOnPublicShareLink';
import { centralizedClipVersionNumberSelector } from '~/store/centralizedClip/selectors';
import { usePublicVersionsList } from '~/swr-hooks/versions/usePublicVersionsList';

export const PublicAssetVersionChip = memo(() => {
  const { canViewAllVersions: canViewVersions } = useCanViewAllVersionsOnPublicShareLink();
  const viewedVersionNumber = useSelector(centralizedClipVersionNumberSelector);
  const { data: versionsList } = usePublicVersionsList();
  const { toggleVersionsPanel } = useVersionsPanelToggle();

  const headVersionNumber = useMemo(() => {
    const versions = versionsList?.data?.clips ?? [];

    return versions.find((version) => version.isDefault)?.version;
  }, [versionsList]);

  if (!versionsList || !canViewVersions) {
    return null;
  }

  return (
    <AssetVersionChip
      data-testid="PUBLIC_ASSET_HEADER_VERSION_CHIP"
      defaultVersionNumber={headVersionNumber}
      onClick={toggleVersionsPanel}
      viewedVersionNumber={viewedVersionNumber}
    />
  );
});

PublicAssetVersionChip.displayName = 'PublicAssetVersionChip';
